import { cn } from '@/lib/utils'
import { ReactNode } from 'react'

interface RadioCardProps {
  label: string
  description?: string
  value: string
  selected: boolean
  onChange: (value: string) => void
  disabled?: boolean
  icon?: ReactNode
}

export function RadioCard({
  label,
  description,
  value,
  selected,
  onChange,
  disabled = false,
  icon,
}: RadioCardProps) {
  return (
    <button
      type="button"
      disabled={disabled}
      onClick={() => onChange(value)}
      className={cn(
        'flex w-full cursor-pointer items-start gap-3 rounded-xl border bg-white p-4 text-left transition-all',
        selected
          ? 'border-[#151515] shadow-[inset_0_0_0_1px_#151515]'
          : 'border-[#e9eaeb] hover:border-[#d5d7da]',
        disabled && 'cursor-not-allowed opacity-50'
      )}
    >
      {/* Icon */}
      {icon && (
        <div className="flex h-6 w-6 flex-shrink-0 items-center justify-center">
          {icon}
        </div>
      )}
      
      {/* Content */}
      <div className="flex flex-1 flex-col">
        <span className="text-base font-medium leading-6 text-[#414651]">
          {label}
        </span>
        {description && (
          <span className="text-sm leading-5 text-[#535862]">
            {description}
          </span>
        )}
      </div>

      {/* Radio indicator */}
      <div
        className={cn(
          'mt-0.5 flex h-4 w-4 flex-shrink-0 items-center justify-center rounded-full',
          selected
            ? 'bg-[#0a0d12]'
            : 'border border-[#d5d7da] bg-white'
        )}
      >
        {selected && (
          <div className="h-1.5 w-1.5 rounded-full bg-white" />
        )}
      </div>
    </button>
  )
}
